export default "__VITE_ASSET__L3Ml3GCZ__"